<template>
  <ax-dialog 
    ref="dialog"
    title="Export type curves" 
    icon="mdi-export" 
    tooltip="Export type curves"
    size="medium" 
    @submitted="onSubmit"
    @shown="onShow"
  >
    <template slot="content">
      <v-card-text>
        <v-radio-group v-model="exportType" row :rules="rules.required">
          <v-radio v-for="(type, t) in types" :key="t" :label="type.text" :value="type.value" :disabled="type.disabled"></v-radio>
        </v-radio-group>
        <v-autocomplete v-model="selectedTarget" :items="targets" label="Target" :rules="rules.required" />
        <v-autocomplete v-model="selectedMethod" :items="methods" label="Method" :rules="rules.required" />
        <v-autocomplete v-model="selectedCurves" multiple :items="curves" label="Type curves" clearable :rules="rules.required" />
        <v-checkbox v-model="averageProduction" label="Include average production" hide-details />
        <!-- <v-checkbox v-model="statistics" label="Include summary statistics" hide-details :disabled="['aries'].includes(exportType)" />
        <v-checkbox v-model="identities" label="Include well identifiers" hide-details :disabled="['aries'].includes(exportType)" /> -->
      </v-card-text>
    </template>
  </ax-dialog>
</template>
<script>
import AxDialog from '@/components/dialog'
export default {
  name: "dlgExportTypeCurves",
  props: {
    targets: { type: Array, required: true },
    methods: { type: Array, required: true },
    declined: { type: Boolean, default: false },
    terminated: { type: Boolean, default: false }
  },
  components: { 
    AxDialog
  },
  data() {
    return {
      types: [
        { text: 'Excel', value: 'excel', disabled: false },
        { text: 'ARIES', value: 'aries', disabled: false },
      ],
      curves: ['P10','P50','P90'],
      exportType: 'excel',
      selectedTarget: null,
      selectedMethod: null,
      selectedCurves: [],
      averageProduction: false,
      // parameters: false,
      // statistics: false,
      // identities: false,
      rules: {}
    }
  },
  computed: {
    multiples() {
      return this.exportType == 'aries'
    },
    width() {
      if (this.size == 'small') return 300
      else if (this.size == 'medium') return 600
      else if (this.size == 'large') return 900
      else return null
    },
  },
  // watch: {
  //   "exportType": function(val) {
  //     if (!!this.show) {
  //       if (val == 'aries') {
  //         this.statistics = false
  //         this.identities = false
  //       }
  //     }
  //   }
  // },
  methods: {
    onShow() {
      this.rules = {}
      let aries = this.types.find(t => t.value == 'aries')
      aries.disabled = !this.declined
      this.exportType = 'excel'
    },
    onSubmit() {
      this.rules = {
        required: [
          v => !!v || 'Required',
          v => !this.isEmpty(v)
        ]
      }
      this.$nextTick(() => {
        //manually trigger Vuetify validation
        if (this.$refs.dialog.$refs.form.validate()) {
          this.$refs.dialog.show = false
          this.$emit('submitted', {
            method: this.exportType, 
            config: {
              target: this.selectedTarget,
              method: this.selectedMethod,
              curves: this.selectedCurves,
              production: this.averageProduction,
              // statistics: this.statistics,
              // identities: this.identities
            }
          })
        }
      })
    }
  }
}
</script>